"use strict";function s(r,n){if(r==null)return{};var o={},i=Object.keys(r),e,t;for(t=0;t<i.length;t++)e=i[t],!(n.indexOf(e)>=0)&&(o[e]=r[e]);return o}exports._objectWithoutPropertiesLoose=s;
